<app-trip-manifest-tabs></app-trip-manifest-tabs>
